import { ReadRequest } from "~/backendApis/foundation/ReadRequest"
import { NumberOfProjectApplicationsForProjectView } from "~/backendApis/viewModel/matching"

interface Params {
  universalCorporationId: string
  projectId: string
}

export class CountApplicationsForProjectReadRequest extends ReadRequest<NumberOfProjectApplicationsForProjectView> {
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public get(): Promise<NumberOfProjectApplicationsForProjectView> {
    return this.apiClient.get(this.makeEndpoint())
  }

  private makeEndpoint(): string {
    const { universalCorporationId, projectId } = this.params
    return `/matching/corporation_member/${universalCorporationId}/project_application/count_for_project?projectId=${projectId}`
  }
}
